import { ReactNode } from 'react';

export enum CardType {
  CREDIT_CARD = 'creditCards',
  GIFT_CARD = 'giftCards',
  CHECKING_ACCOUNT = 'checkingAccounts',
  KEY_TAG = 'keyTags',
  PRO_XTRA_DOLLARS = 'proxPerksCard',
  PAYPAL_ACCOUNT = 'payPalAccounts',
  PRO_HOUSE_ACCOUNT = 'proHouseAccount',
}

export type TMeatBallsAnalyticsAction =
  | 'edit'
  | 'set inactive'
  | 'set active'
  | 'remote purchases'
  | 'delete'
  | 'set default'
  | 'hd pass'
  | 'remove hd pass'
  | 'edit user permissions';

export const NULLIFY_FIELD = 'NULLIFY_FIELD';

export type TSearchableCardTypes =
  | CardType.CREDIT_CARD
  | CardType.GIFT_CARD
  | CardType.CHECKING_ACCOUNT
  | CardType.PAYPAL_ACCOUNT
  | CardType.PRO_XTRA_DOLLARS;

export const cardTypeSearchMapping: Record<
  TSearchableCardTypes,
  TSearchSelectorValue
> = {
  [CardType.CREDIT_CARD]: 'creditDebitCard',
  [CardType.GIFT_CARD]: 'giftCard',
  [CardType.CHECKING_ACCOUNT]: 'checkingAccount',
  [CardType.PAYPAL_ACCOUNT]: 'PAYPAL',
  [CardType.PRO_XTRA_DOLLARS]: 'proXtrareloadableCard',
} as const;

export type TSearchSelectorValue =
  | 'giftCard'
  | 'creditDebitCard'
  | 'checkingAccount'
  | 'PAYPAL'
  | 'proXtrareloadableCard';

export type TTitleMessage = {
  title: string;
  message: ReactNode;
  dataTestId?: string;
};

export enum T2CStatus {
  ENROLLED = 'ENROLLED',
  PENDING = 'PENDING',
}

export const HDPASS_URL_PARAM = 'hdwallet';
